/** Correlates one scheduling session (online or internal tools) across telemetry and API calls. */

export const SCHEDULER_RUN_HEADER = 'x-attik-scheduler-run-id';
export const SCHEDULER_RUN_COOKIE = 'attik_scheduler_run_id';
export const SCHEDULER_RUN_STORAGE_KEY = 'attik_scheduler_run_id';

/** Online scheduler: CRM contact id after email step, forwarded to Express when no platform auth exists. */
export const SCHEDULER_CONTACT_HEADER = 'x-attik-scheduler-contact-id';
export const SCHEDULER_CONTACT_COOKIE = 'attik_scheduler_contact_id';

/**
 * Returns a stable UUID for this tab’s scheduler session (sessionStorage).
 * Call from the browser only; server returns ''.
 */
export function getOrCreateSchedulerRunId(): string {
  if (typeof window === 'undefined') return '';
  try {
    let id = sessionStorage.getItem(SCHEDULER_RUN_STORAGE_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SCHEDULER_RUN_STORAGE_KEY, id);
    }
    return id;
  } catch {
    return '';
  }
}

/** Existing run id only (no create). Used for outbound headers outside the provider init. */
export function getSchedulerRunId(): string {
  if (typeof window === 'undefined') return '';
  try {
    return sessionStorage.getItem(SCHEDULER_RUN_STORAGE_KEY) ?? '';
  } catch {
    return '';
  }
}
